var radius = {
  none: 0,
  sm: 2,
  md: 4,
  lg: 6
};
export default radius;